import { render, staticRenderFns } from "./CollapsibleDescription.vue?vue&type=template&id=2eccf776"
import script from "./CollapsibleDescription.vue?vue&type=script&lang=ts"
export * from "./CollapsibleDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eccf776')) {
      api.createRecord('2eccf776', component.options)
    } else {
      api.reload('2eccf776', component.options)
    }
    module.hot.accept("./CollapsibleDescription.vue?vue&type=template&id=2eccf776", function () {
      api.rerender('2eccf776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CollapsibleDescription.vue"
export default component.exports